module.exports = __webpack_public_path__ + "static/male04-beecce9ed63180baa8721fc738a45fb8.png";